// extracted by mini-css-extract-plugin
module.exports = {"deleted":"HashtagReport_deleted_3fsBP","holder":"HashtagReport_holder_34lke"};